import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    empresa: '',
    instagram: '',
    website: '',
    clientesActuales: '',
    metaClientes: '',
    haHechoAds: 'no',
    inversionAds: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');
    // CONFIGURACIÓN DE EMAILJS
    // Reemplaza estos valores con los de tu cuenta de EmailJS (Doctor Ecommerce)
    const serviceID = 'YOUR_SERVICE_ID';
    const templateID = 'YOUR_TEMPLATE_ID';
    const publicKey = 'YOUR_PUBLIC_KEY';
    try {
      const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          service_id: serviceID,
          template_id: templateID,
          user_id: publicKey,
          template_params: {
            to_email: 'doctor.ecommerceus@gmail.com',
            ...formData
          }
        })
      });
      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          empresa: '',
          instagram: '',
          website: '',
          clientesActuales: '',
          metaClientes: '',
          haHechoAds: 'no',
          inversionAds: ''
        });
      } else {
        // Si no has configurado EmailJS aún, simularemos éxito para la demo
        console.warn('EmailJS no configurado. Simulando éxito.');
        setTimeout(() => setSubmitStatus('success'), 1000);
      }
    } catch (error) {
      console.error('Error enviando formulario:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="contacto" className="py-24 px-4 bg-dark relative z-10" data-id="element-9">
      <div className="max-w-4xl mx-auto" data-id="element-10">
        <div className="text-center mb-12" data-id="element-11">
          <h2 className="text-3xl md:text-5xl font-black text-gold mb-4 uppercase" data-id="element-12">
            Aplica para tu Zona
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-13">
            Completa este diagnóstico para evaluar si tu negocio califica para
            nuestro sistema de inyección de leads.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-card p-8 md:p-12 rounded-2xl border border-emerald/30 shadow-neon-green" data-id="element-14">
          {submitStatus === 'success' ? <div className="text-center py-16" data-id="element-15">
              <div className="w-20 h-20 bg-emerald/20 rounded-full flex items-center justify-center mx-auto mb-6 border border-emerald" data-id="element-16">
                <svg className="w-10 h-10 text-emerald" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-17">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-18"></path>
                </svg>
              </div>
              <h3 className="text-3xl font-bold text-white mb-4" data-id="element-19">
                ¡Diagnóstico Recibido!
              </h3>
              <p className="text-gray-400 text-lg mb-8" data-id="element-20">
                Nuestro equipo revisará tu información y te contactaremos a la
                brevedad.
              </p>
              <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="inline-block bg-gold text-dark font-bold px-8 py-4 rounded-full hover:scale-105 transition-transform shadow-neon-gold" data-id="element-21">
                ACELERA EL PROCESO: AGENDA TU CITA AHORA
              </a>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-22">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-23">
                <div data-id="element-24">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-25">
                    Nombre Completo *
                  </label>
                  <input required type="text" name="nombre" value={formData.nombre} onChange={handleChange} className="w-full bg-dark border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-emerald focus:ring-1 focus:ring-emerald transition-colors" placeholder="Ej. Juan Pérez" data-id="element-26" />
                </div>
                <div data-id="element-27">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-28">
                    Email *
                  </label>
                  <input required type="email" name="email" value={formData.email} onChange={handleChange} className="w-full bg-dark border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-emerald focus:ring-1 focus:ring-emerald transition-colors" placeholder="juan@plomeria.com" data-id="element-29" />
                </div>
                <div data-id="element-30">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-31">
                    Teléfono (WhatsApp) *
                  </label>
                  <input required type="tel" name="telefono" value={formData.telefono} onChange={handleChange} className="w-full bg-dark border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-emerald focus:ring-1 focus:ring-emerald transition-colors" placeholder="+1 (402) 872-0639" data-id="element-32" />
                </div>
                <div data-id="element-33">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-34">
                    Nombre de la Compañía *
                  </label>
                  <input required type="text" name="empresa" value={formData.empresa} onChange={handleChange} className="w-full bg-dark border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-emerald focus:ring-1 focus:ring-emerald transition-colors" placeholder="Plomería Express LLC" data-id="element-35" />
                </div>
                <div data-id="element-36">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-37">
                    Instagram de la Compañía
                  </label>
                  <input type="text" name="instagram" value={formData.instagram} onChange={handleChange} className="w-full bg-dark border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-emerald focus:ring-1 focus:ring-emerald transition-colors" placeholder="@tuempresa" data-id="element-38" />
                </div>
                <div data-id="element-39">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-40">
                    Sitio Web (si tienes)
                  </label>
                  <input type="url" name="website" value={formData.website} onChange={handleChange} className="w-full bg-dark border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-emerald focus:ring-1 focus:ring-emerald transition-colors" placeholder="https://tuempresa.com" data-id="element-41" />
                </div>
                <div data-id="element-42">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-43">
                    ¿Cuántos clientes nuevos tienes por semana? *
                  </label>
                  <input required type="number" name="clientesActuales" value={formData.clientesActuales} onChange={handleChange} className="w-full bg-dark border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-emerald focus:ring-1 focus:ring-emerald transition-colors" placeholder="Ej. 5" data-id="element-44" />
                </div>
                <div data-id="element-45">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-46">
                    ¿Cuál es tu meta de clientes nuevos por semana? *
                  </label>
                  <input required type="number" name="metaClientes" value={formData.metaClientes} onChange={handleChange} className="w-full bg-dark border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-emerald focus:ring-1 focus:ring-emerald transition-colors" placeholder="Ej. 20" data-id="element-47" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4 border-t border-gray-800" data-id="element-48">
                <div data-id="element-49">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-50">
                    ¿Has hecho publicidad antes (Google/Facebook Ads)? *
                  </label>
                  <select name="haHechoAds" value={formData.haHechoAds} onChange={handleChange} className="w-full bg-dark border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-emerald focus:ring-1 focus:ring-emerald transition-colors" data-id="element-51">
                    <option value="no" data-id="element-52">No, nunca</option>
                    <option value="si_poco" data-id="element-53">
                      Sí, pero con pocos resultados
                    </option>
                    <option value="si_mucho" data-id="element-54">
                      Sí, invierto constantemente
                    </option>
                  </select>
                </div>
                <div data-id="element-55">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-56">
                    ¿Cuánto has gastado en publicidad aprox? (USD)
                  </label>
                  <input type="text" name="inversionAds" value={formData.inversionAds} onChange={handleChange} className="w-full bg-dark border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-emerald focus:ring-1 focus:ring-emerald transition-colors" placeholder="Ej. $1,000" data-id="element-57" />
                </div>
              </div>

              {submitStatus === 'error' && <p className="text-red-500 text-sm text-center" data-id="element-58">
                  Hubo un error al enviar. Por favor intenta de nuevo o
                  contáctanos directamente.
                </p>}

              <div className="pt-6 flex flex-col items-center" data-id="element-59">
                <button type="submit" disabled={isSubmitting} className="w-full md:w-auto px-12 py-5 text-xl font-black text-dark bg-gold rounded-full transition-all hover:scale-105 shadow-neon-green hover:shadow-neon-green-lg disabled:opacity-70 disabled:hover:scale-100" data-id="element-60">
                  {isSubmitting ? 'ENVIANDO DIAGNÓSTICO...' : 'ENVIAR DIAGNÓSTICO'}
                </button>
                <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="mt-6 text-emerald hover:text-gold transition-colors font-semibold underline underline-offset-4" data-id="element-61">
                  O agenda tu cita directamente en nuestro calendario
                </a>
              </div>
            </form>}
        </motion.div>
      </div>
    </section>;
}